import FileReferenceDefinition from '../FileReferenceDefinition';

const definition: FileReferenceDefinition = {
  name: 'WebPluginType',
  type: 'enum',
  description: 'Identifies the type of webview implementation in use at runtime. Used by [IWebView.PluginType](/webview/IWebView#PluginType) and [Web.DefaultPluginType](/webview/Web#DefaultPluginType).',
  members: [
    {
      name: 'Android',
      type: 'value',
      description: 'The plugin type for [AndroidWebView](/webview/AndroidWebView).'
    },
    {
      name: 'AndroidGecko',
      type: 'value',
      description: 'The plugin type for [AndroidGeckoWebView](/webview/AndroidGeckoWebView).'
    },
    {
      name: 'iOS',
      type: 'value',
      description: 'The plugin type for [iOSWebView](/webview/iOSWebView).'
    },
    {
      name: 'MacWebKit',
      type: 'value',
      description: 'The plugin type for [MacWebKitWebView](/webview/MacWebKitWebView).'
    },
    {
      name: 'Mock',
      type: 'value',
      description: 'The plugin type for the [Mock WebView](https://support.vuplex.com/articles/mock-webview/).'
    },
    {
      name: 'Standalone',
      type: 'value',
      description: 'The plugin type for [StandaloneWebView](/webview/StandaloneWebView).'
    },
    {
      name: 'UniversalWindowsPlatform',
      type: 'value',
      description: 'The plugin type for [UwpWebView](/webview/UwpWebView).'
    },
    {
      name: 'VisionOS',
      type: 'value',
      description: 'The plugin type for [VisionOSWebView](/webview/VisionOSWebView).'
    },
    {
      name: 'WebGL',
      type: 'value',
      description: 'The plugin type for [WebGLWebView](/webview/WebGLWebView).'
    },
  ]
};
export default definition;
